import React from 'react';
import { Switch, Route, Redirect } from 'react-router';

import AuthOrApp from './authOrApp'
import Dashboard from '../dashboard/dashboard';
import Usuario from '../usuario/usuario';
import CompraStatus from '../compraStatus/compraStatus';
import CompraCategoria from '../compraCategoria/compraCategoria';
import CompraTipo from '../compraTipo/compraTipo';
import Prioridade from '../prioridade/prioridade';
import FormaPagamento from '../formaPagamento/formaPagamento';
import Cliente from '../cliente/cliente';
import Fornecedor from '../fornecedor/fornecedor';
import Transportadora from '../transportadora/transportadora';
import Produto from '../produto/produto';
import SolicitacaoCompra from '../solicitacaoCompra/solicitacaoCompra';
import Pedido from '../pedido/pedido';

export default props => (
	<div id='id-content-wrapper' className='content-wrapper' >
		<Switch>
			<Route exact path='/' component={Dashboard} />
			<Route path='/usuario' component={Usuario} />
			<Route path='/compraStatus' component={CompraStatus} />
			<Route path='/compraCategoria' component={CompraCategoria} />
			<Route path='/compraTipo' component={CompraTipo} />
			<Route path='/prioridade' component={Prioridade} />
			<Route path='/formaPagamento' component={FormaPagamento} />
			<Route path='/cliente' component={Cliente} />
			<Route path='/fornecedor' component={Fornecedor} />
			<Route path='/transportadora' component={Transportadora} />
			<Route path='/produto' component={Produto} />
			<Route path='/solicitacaoCompra' component={SolicitacaoCompra} />
			<Route path='/pedido' component={Pedido} />
			<Redirect from='*' to='/' />
		</Switch>
	</div>
);
